module.exports = __webpack_public_path__ + "img/co-branding-logo-papa-johns.38e877dc.png";